import { render, staticRenderFns } from "./ListItemWithCheckbox.vue?vue&type=template&id=2bea515a"
import script from "./ListItemWithCheckbox.vue?vue&type=script&lang=js"
export * from "./ListItemWithCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ListItemWithCheckbox.vue?vue&type=style&index=0&id=2bea515a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports